import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const WebsiteContent = () => {
  const navigate = useNavigate();
  const [websiteContent, setWebsiteContent] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const articleid = window.location.href.split('/').pop();
        if (articleid) {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/website-content/id/${articleid}`);
          const newContent = response.data[0].content.replace(/\r\n/g, '<br/>');
          response.data[0].content = newContent;
          setWebsiteContent(response.data[0]);
        } else {
          navigate('/website-content/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <PageHeader title="Website Content Details" description="" className="mb-3"></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : websiteContent?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Title: {websiteContent.title}</td>
            </tr>
            <tr>
              <td>Section: {websiteContent.section}</td>
            </tr>
            <tr>
              <td>Enabled: {websiteContent.enabled}</td>
            </tr>
            <tr>
              <td>
                Content: <div className="news-body" dangerouslySetInnerHTML={{ __html: websiteContent.content }}></div>
              </td>
            </tr>
            <tr>
              <td>Post date: {websiteContent.created_at}</td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Content not found</div>
      )}
    </>
  );
};

export default WebsiteContent;
